import styled from "styled-components";

const opensans = (props) => props.theme.fonts.opensans;
const darkred = (props) => props.theme.palette.darkred;

export const CustomSpan = styled.span`
  font-family: ${opensans};
  color: ${darkred};
`;
